import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import Seo from '@/components/base/Seo';
import CourseHero from './components/CourseHero';
import ProblemSolution from './components/ProblemSolution';
import PathsSection from './components/PathsSection';
import ToolsAndAudience from './components/ToolsAndAudience';
import DifferenceAndCTA from './components/DifferenceAndCTA';

const COURSE_TITLE = 'The Energy Safe Journey Course | Healing & Breakthrough';
const COURSE_DESCRIPTION =
  'The Energy Safe Journey — a self-paced course from Healing & Breakthrough built for chronic illness, ADHD/Autism sensory drain and life-demand mismatch. Break the Boom & Bust cycle with Energy-Safe Motions.';

const courseJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Course',
  name: 'The Energy Safe Journey Course',
  description:
    'A self-paced online course from Healing & Breakthrough that teaches the Energy-Safe Method: nervous-system-informed coaching for chronic illness, ADHD/Autism sensory drain and life-demand mismatch, using Energy-Safe Motions to break the boom-and-bust cycle.',
  provider: {
    '@type': 'Organization',
    name: 'Healing & Breakthrough',
    url: 'https://healing-breakthrough.com/',
  },
  offers: {
    '@type': 'Offer',
    price: '97',
    priceCurrency: 'GBP',
    availability: 'https://schema.org/InStock',
    url: 'https://federica-tedeschi3.systeme.io/course',
  },
  inLanguage: 'en',
  audience: {
    '@type': 'EducationalAudience',
    educationalRole: 'student',
  },
};

export default function CoursePage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Seo
        title={COURSE_TITLE}
        description={COURSE_DESCRIPTION}
        canonicalPath="/course"
        jsonLd={courseJsonLd}
      />
      <Navbar />
      <main>
        <CourseHero />
        <ProblemSolution />
        <PathsSection />
        <ToolsAndAudience />
        <DifferenceAndCTA />
      </main>
      <Footer />
    </div>
  );
}